module.exports = __webpack_public_path__ + "static/img/logo_bg.3d4bcb0a.png";